
<dialog-wrapper (onClose)="wrapperClose()" #wrapper>

  <div class="modal-header">

    <div class="title-wrapper">
      <span aria-hidden="true" class="material-symbols-sharp tkt-icon">
        translate
      </span>
      <h3 class="modal-title">{{ "LanguageDialog.TITLE" | translate}}</h3>
    </div>

    <button (click)="onCloseDialog()"
      [attr.aria-label]="'Modale.BTN_CHIUDI' | translate"
      role="button">
        <span aria-hidden="true" class="material-symbols-sharp">close</span>
    </button>
  </div>

  <div id="supported-languages">

    <form>

      <fieldset>

        @for (lang of supportedLanguages; track $index) {
          <label class="language-item" [for]="'lang-' + lang.lang_code" [class]="{ 'selected': selectedLang && selectedLang.lang_code == lang.lang_code }">
            <input class="lang-radio"
              [id]="'lang-' + lang.lang_code"
              type="radio"
              name="lang-choice"
              [alt]="('Header.LANG_DROP_DOWN' | translate) + ': ' + (lang.name_original_lang ? lang.name_original_lang : lang.name)"
              [value]="lang"
              [(ngModel)]="selectedLang"
              tabindex="0"
            >
            <div class="lang-name-container">
              <span class="lang-name">{{ lang.name_original_lang ? lang.name_original_lang : lang.name }}</span>
              <span class="lang-original-name">{{ lang.name }}</span>
            </div>
          </label>
        }

      </fieldset>

    </form>
  </div>

  <div class="bottom-sect">
    <button id="select-lang" (click)="selectLanguage()">
      <span>{{ "LanguageDialog.CONFIRM_BTN" | translate}}</span>
    </button>
  </div>

</dialog-wrapper>
